import React, {Component, Fragment} from 'react';
import {withLocalize} from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import {capitalizeFirstLetter} from '../../../app/utils/text';

class HeaderLanguages extends Component {
    state = {
        anchorEl: null,
    };

    handleClickMenuLangs = e => {
        this.setState({
            anchorEl: e.currentTarget
        });
    };

    handleCloseMenuLangs = () => {
        this.setState({
            anchorEl: null
        });
    };

    handleSelectLang = (code) => {
        this.props.setActiveLanguage(code);
        this.setState({
            anchorEl: null
        });
    };

    render() {
        const {anchorEl} = this.state;
        const {languages, activeLanguage} = this.props;

        if (activeLanguage === undefined) {
            return (<Fragment></Fragment>);
        }

        return (
            <div className="langsDropdown">
                <Button
                    className="langsDropdown-button"
                    size="small"
                    aria-owns={anchorEl ? 'simple-menu' : null}
                    aria-haspopup="true"
                    onClick={this.handleClickMenuLangs}
                >
                    {activeLanguage && activeLanguage.hasOwnProperty('code') && activeLanguage.code !== '' ? capitalizeFirstLetter(activeLanguage.code) : 'Fr' }
                    <Icon className="langsDropdownIcon">keyboard_arrow_down</Icon>
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleCloseMenuLangs}
                >
                    {languages.map(lang => (
                        <MenuItem key={lang.code} selected={activeLanguage.code === lang.code} onClick={() => this.handleSelectLang(lang.code)}>{lang.name}</MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}

export default withLocalize(HeaderLanguages);


// WEBPACK FOOTER //
// ./src/features/Layout/components/HeaderLanguages.js